import {IController, IModule, IOnChangesObject} from "angular";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {RevisjonsloggRessurs} from "felles/tjenester/ressurser/RevisjonsloggRessurs";

require('./endringshendelser.scss');

export class MøteEndringshendelserKontroller implements IController {
    static registrerKomponent(angular: IModule) {
        angular
            .component('wmMoeteEndringshendelser', {
                bindings: {moeteId: "<"},
                controller: MøteEndringshendelserKontroller.forInjisering(),
                template: require('./endringshendelser.html')
            });
    }

    static forInjisering() {
        return [
            WebNavigasjon.regNavn,
            RevisjonsloggRessurs.regNavn,
            MøteEndringshendelserKontroller
        ]
    }

    constructor(private navigasjon: WebNavigasjon,
                private revisjonsloggRes: RevisjonsloggRessurs) {
    }

    moeteId: string; //settes via bindings/$onChanges

    lastHendelser(offset: number, antall: number) {
        return this.revisjonsloggRes.finnEndringerKnyttetTilMøte(this.moeteId, offset, antall).$promise
    }

    $onChanges(changes: IOnChangesObject) {
    }

    //hjelpemetoder

}

